require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/core-js/modules/es6.array.species.js
// module id = 671
// module chunks = 20